import { View, SxProp } from 'dripsy';
import { TextCaption } from '../../typography';
import { UniButton } from '../UniButton';

interface InstructionButtonProps {
  title: string;
  text: string;
  label: string;
  onPress: () => void;
  sx?: SxProp;
  buttonSx?: SxProp;
}

export const InstructionButton: React.FC<InstructionButtonProps> = ({ title, text, label, onPress, sx, buttonSx }) => {
  return (
    <View sx={{ ...styles.container, ...sx }}>
      <View sx={styles.containerLeft}>
        <TextCaption bold label>
          {title}
        </TextCaption>
        <TextCaption secondary sx={{ wordBreak: 'break-word' }}>
          {text}
        </TextCaption>
      </View>
      <View sx={styles.containerRight}>
        <UniButton size="small" label={label} onPress={onPress} sx={{ ...styles.button, ...buttonSx }} />
      </View>
    </View>
  );
};

enum StyleName {
  container = 'container',
  containerLeft = 'containerLeft',
  containerRight = 'containerRight',
  button = 'button'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '$3'
  },
  containerLeft: {
    flex: 1
  },
  containerRight: {},
  button: {
    width: '$20'
  }
};
